exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".toggle[data-v-416b8dda]{overflow:hidden;transition:height .3s ease-in-out}", ""]);

